// PC / 모바일이 같은 규칙으로 검증하도록 공통 모듈로 분리한다.

export const EMAIL_REGEX = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,4}$/;

// 특수문자 1개 이상 + 4자리 이상
export const PASSWORD_REGEX = /^(?=.*[^A-Za-z0-9\s]).{4,30}$/;

// 메모 최대 글자 수. 서버(Estimate.MEMO_MAX_LENGTH)·DB 칸 길이와 같아야 한다.
// 서버가 받지 못하는 길이를 화면에서 미리 알려 주지 않으면 손님이 접수 실패를 늦게 안다.
export const MEMO_MAX_LENGTH = 2000;

export const PASSWORD_HELPER = '4자리 이상, 특수문자(!@#$ 등) 1개 이상 포함';
export const PHONE_HELPER = "'-' 없이 숫자만 입력";

/** 숫자만 남긴다 (입력 단계에서 사용) */
export const onlyDigits = (value) => String(value ?? '').replace(/[^0-9]/g, '');

/** 숫자 입력칸 keydown 가드 - 숫자/제어키만 허용 */
export const blockNonDigitKey = (event) => {
  const allowed = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
  if (allowed.includes(event.key) || event.ctrlKey || event.metaKey) return;
  if (!/^[0-9]$/.test(event.key)) event.preventDefault();
};

export const isValidEmail = (email) => EMAIL_REGEX.test(String(email ?? '').trim());
export const isValidPassword = (password) => PASSWORD_REGEX.test(String(password ?? ''));
export const isValidPhone = (phone) => /^[0-9]{10,11}$/.test(onlyDigits(phone));

/**
 * 견적 폼 전체 검증. 일반/통근 공통 규칙 + 종류별 규칙을 한 곳에서 관리한다.
 * @returns {Object} 필드명 -> 오류 메시지 (빈 객체면 통과)
 */
export function validateEstimateForm(form, estimateType) {
  const errors = {};
  const isCommute = estimateType === '통근';

  if (!form.name?.trim()) errors.name = '이름을 입력해주세요.';

  if (!form.phone?.trim()) errors.phone = '연락처를 입력해주세요.';
  else if (!isValidPhone(form.phone)) errors.phone = "'-' 없이 숫자만 10~11자리로 입력해주세요.";

  // 이메일은 선택 항목이다. 다만 '이메일로 견적받기'를 선택했다면 보낼 곳이 있어야 하므로
  // 그때만 필수가 된다. 입력했으면 선택 여부와 상관없이 형식은 확인한다.
  if (form.emailReceipt && !form.email?.trim()) {
    errors.email = '이메일로 견적을 받으려면 이메일을 입력해주세요.';
  } else if (form.email?.trim() && !isValidEmail(form.email)) {
    errors.email = '이메일 형식에 맞게 입력해주세요.';
  }

  if (!form.vehicleType) errors.vehicleType = '차량 종류를 선택해주세요.';
  if (!form.vehicleNumber) errors.vehicleNumber = '차량 대수를 선택해주세요.';

  if (!form.departPlace?.trim()) errors.departPlace = '출발지를 입력해주세요.';
  if (!form.arrivalPlace?.trim()) errors.arrivalPlace = '도착지를 입력해주세요.';

  if (isCommute) {
    if (!form.companyName?.trim()) errors.companyName = '회사명을 입력해주세요.';
    if (!form.commuteStartTime) errors.commuteStartTime = '출근(출발) 시간을 선택해주세요.';
    if (!form.commuteEndTime) errors.commuteEndTime = '퇴근 시간을 선택해주세요.';
    if (!form.workType) errors.workType = '운행형태를 선택해주세요.';
    if (!form.workDays) errors.workDays = '근무일을 선택해주세요.';
  } else {
    if (!form.departDate) errors.departDate = '출발일자를 선택해주세요.';
    if (!form.arrivalDate) errors.arrivalDate = '귀행일자를 선택해주세요.';
    else if (form.arrivalDate < form.departDate) errors.arrivalDate = '귀행일자가 출발일자보다 빠릅니다.';
  }

  const memoLength = (form.memo ?? '').trim().length;
  if (memoLength > MEMO_MAX_LENGTH) {
    errors.memo = `메모는 ${MEMO_MAX_LENGTH.toLocaleString()}자까지 적을 수 있습니다. ` +
      `${(memoLength - MEMO_MAX_LENGTH).toLocaleString()}자를 줄여주세요.`;
  }

  return errors;
}
